/**
 * @param {unknown} v
 */
function isBlankMergeValue(v) {
  return v === null || v === undefined || v === "";
}

/**
 * Object.assign — אבל null/ריק לא דורס מספר תקף קיים בשדות מחיר (slim API שולח price_child:null).
 * @param {Record<string, unknown>} out
 * @param {Record<string, unknown>} src
 */
function assignLayerWithoutNullWipingKnownPrices(out, src) {
  for (const key of Object.keys(src)) {
    const incoming = src[key];
    const existing = out[key];
    const existingNum = Number(existing);
    const kl = key.toLowerCase();
    if (
      isBlankMergeValue(incoming) &&
      Number.isFinite(existingNum) &&
      existingNum >= 0 &&
      (kl.includes("price") || kl.endsWith("_ils") || kl === "sell_value" || kl === "price_value")
    ) {
      continue;
    }
    out[key] = incoming;
  }
}

/**
 * מאחד שדות מחיר מאטרקציה/חוק/קטלוג כולל אובייקטים מקוננים נפוצים מה-API.
 * @param {...Record<string, unknown>|null|undefined} sources
 * @returns {Record<string, unknown>}
 */
export function mergeAttractionPricingLayers(...sources) {
  const out = {};
  const nestedKeys = [
    "pricing",
    "pricing_rows",
    "internal_pricing",
    "attraction_pricing",
    "unit_prices",
    "default_prices",
  ];
  for (const src of sources) {
    if (!src || typeof src !== "object") continue;
    assignLayerWithoutNullWipingKnownPrices(out, src);
    for (const nk of nestedKeys) {
      const sub = src[nk];
      if (sub && typeof sub === "object" && !Array.isArray(sub)) {
        assignLayerWithoutNullWipingKnownPrices(out, sub);
      } else if (Array.isArray(sub) && sub.length > 0) {
        // למשל pricing: [{ price_adult, price_child, ... }] — ללא זה המפתחות לא נכנסים ל-merged
        const first = sub[0];
        if (first && typeof first === "object" && !Array.isArray(first)) {
          assignLayerWithoutNullWipingKnownPrices(out, first);
        }
      }
    }
  }
  return out;
}
